export var DesignLeftSideBarTabs;
(function (DesignLeftSideBarTabs) {
    DesignLeftSideBarTabs["VIEWS"] = "VIEWS";
    DesignLeftSideBarTabs["COMPONENTS"] = "COMPONENTS";
    DesignLeftSideBarTabs["CEILING_VALIDATIONS"] = "CEILING_VALIDATIONS";
    DesignLeftSideBarTabs["DEVICE_HISTORY"] = "DEVICE_HISTORY";
    DesignLeftSideBarTabs["CEILING_HELP"] = "CEILING_HELP";
    DesignLeftSideBarTabs["CEILING_SETTINGS"] = "CEILING_SETTINGS";
    DesignLeftSideBarTabs["MCBIMITEM_INFO"] = "MCBIMITEM_INFO";
    DesignLeftSideBarTabs["ROUTING_GRAPHS"] = "ROUTING_GRAPHS";
    DesignLeftSideBarTabs["DROFUS_CHANGES"] = "DROFUS_CHANGES";
})(DesignLeftSideBarTabs || (DesignLeftSideBarTabs = {}));
export var RoomSideBarTabs;
(function (RoomSideBarTabs) {
    RoomSideBarTabs["CEILING_MULTIPLACER_PRODUCTS"] = "CEILING_MULTIPLACER_PRODUCTS";
    RoomSideBarTabs["CEILING_STANDARD_ROOM"] = "CEILING_STANDARD_ROOM";
    RoomSideBarTabs["CEILING_VALIDATIONS"] = "CEILING_VALIDATIONS";
    RoomSideBarTabs["CEILING_AI_PREDICTIONS"] = "CEILING_AI_PREDICTIONS";
    RoomSideBarTabs["CEILING_COMMENTS"] = "CEILING_COMMENTS";
    RoomSideBarTabs["ROOM_SECTION_VIEWS"] = "ROOM_SECTION_VIEWS";
    RoomSideBarTabs["RFP_STANDARD_ROOM_DIFF"] = "RFP_STANDARD_ROOM_DIFF";
    RoomSideBarTabs["ROOM_SPECIFIED_ARTICLES"] = "ROOM_SPECIFIED_ARTICLES";
    RoomSideBarTabs["ROOM_NUMBERING_DETAILS"] = "ROOM_NUMBERING_DETAILS";
    RoomSideBarTabs["ROOM_INFO"] = "ROOM_INFO";
    RoomSideBarTabs["ROOM_DROFUS_CHANGES"] = "ROOM_DROFUS_CHANGES";
})(RoomSideBarTabs || (RoomSideBarTabs = {}));
